<template>
    <section>
        <div class="expi-verif-wrapper elevation-5">
            <div class="hmi-cross">
                <img src="../../../assets/HMLOGO_WHITE.webp" alt="">
            </div>
            <div class="noti-content-wrapper">
                <div class="mail-svg">
                    <img src="../../../assets/mail-confirmed.svg" alt="">
                </div>
                <div class="noti">
                    <h2>Account is already registered.</h2>
                    <h3>
                        You may close this window or proceed to our
                        <a href="/"><strong>Login Page.</strong></a>
                    </h3>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(['validation4Output'])
    }
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/loginBG.webp");
  background-position: center;
  background-size: cover;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}

h2 {
  font-size: 45px;
  padding: 15px 0px;
}
h3 {
  width: 100%;
  margin: auto;
  font-weight: normal;
}
a {
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 1px;
  color: #00c853;
  padding: 0px 5px;
}
/* Main wrapper */

.hmi-cross {
  position: absolute;
  width: 12%;
  top: 2%;
  left: 1%;
}
.hmi-cross img {
  width: 100%;
}
.expi-verif-wrapper {
  position: relative;
  background-image: url("../../../assets/mail-bg-wrapper.webp");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: white;
  border-radius: 100px 0px 100px 0px;
}
.mail-svg {
  width: 25%;
  font-size: 12px;
  margin: auto;
}
.mail-svg img {
  width: 100%;
}
.noti-content-wrapper {
    max-width: 800px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

.noti {
  width: 90%;
  margin: auto;
}

@media (max-width: 599px) {
  .expi-verif-wrapper {
    margin: 5%;
    background-position: left;
    border-radius: 30px 0px 30px 0px;
  }
  .noti {
    width: 95%;
  }
  .mail-svg {
    width: 40%;
  }
  .hmi-cross {
    width: 20%;
    left: 5%;
  }
  h2 {
    font-size: 25px;
  }
  h3 {
    font-size: 18px;
    padding: 15px 0px;
    width: 95%;
  }
  a {
    font-size: 20px;
    letter-spacing: 1.5px;
    /* color: black; */
  }
}
@media (min-width: 599px) and (max-width: 960px) {
  .expi-verif-wrapper {
    margin: 5%;
    background-position: left;
    border-radius: 60px 0px 60px 0px;
  }
  .noti {
    width: 90%;
  }
  .mail-svg {
    width: 35%;
  }
  .hmi-cross {
    width: 20%;
    left: 5%;
  }
  h2 {
    font-size: 30px;
  }
  h3 {
    width: 70%;
    padding: 15px 0px;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .expi-verif-wrapper {
    margin: 5%;
    background-position: left;
    border-radius: 60px 0px 60px 0px;
  }
  .noti {
    width: 90%;
  }
  .hmi-cross {
    width: 20%;
    left: 5%;
  }
  .mail-svg {
    width: 55%;
  }

  h3 {
    padding: 15px 0px;
    width: 80%;
  }
}
@media (min-width: 1264px) {
  .expi-verif-wrapper {
    margin: 5%;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
    width: 100%;
  }
  .noti {
    width: 50%;
  }

  h3 {
    width: 80%;
    padding: 15px 0px;
  }
}
</style>
